const SearchInput = (props) => {
  return (
    <input
      type="search"
      className="form-control"
      name="search"
      placeholder="Address, City, ZIP, or Neighborhood"
      {...props}
    />
  );
};

export default SearchInput;
